<template>

    <div class="ref-wrap">
        <div class="card" >
            <div class="card-body"><h5 class="card-title m-b-5 title-font" style="
    padding-bottom: 20px;
">{{$t('dashBoard.cSysUserLoginActivity.userLoginActivity')}}
                </h5>
<!--                <h3 class="font-light">$769.08</h3>-->
                <div class="chart-wrap">
                    
                    <CChartBarSimple :dataPoints="chartvalues.dataSets" :label="$t('dashBoard.cSysUserLoginActivity.loginCount')" :labels="chartvalues.labels" background-color="#137eff"/>
                </div>
            </div>
        </div>
    </div>

<!--<CCard >-->

<!--        <CCardHeader>User Login Activity</CCardHeader>-->
<!--        <CCardBody></CCardBody>-->
<!--      </CCard>-->
</template>
<script>
import Logger from "../../../services/logger";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import router, { navigate, goBack } from "../../../router/index";
import apiGetUserLoginActvty from "./../../../services/apiGetUserLoginActvty";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../config/API_DATA";
import CChartBarSimple from "../../chart/CChartBarSimple"
import { COMPONENT_NAME, PATHNAME, BOOKING_STATUS } from "../../../util/constants";
import BaseConfiguration from "../../../config/base.js";
import SERVICE_URL from "../../../config/API_DATA";
import { mapGetters, mapActions } from "vuex";
import { handleJWT, getErrorAlertValue } from "../../../util/util";
import { formatDate } from '../../../util/date/dateFunctions';

export default {
  name: COMPONENT_NAME.C_SYS_USER_LOGIN_ACTIVITY,

  data () {
    return {
        chartvalues :{
            dataSets : [],
            labels: []
        }
    }
   },
   components:{
    CChartBarSimple
},

   computed: {
           ...mapGetters("sSysLogin", {
      ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
    }),
        },
    async created() {
            if (BaseConfiguration.isDebug) console.log("created");
            try {
                if (this.ADMIN_SIGNIN_RES) {
                    let sysloginActvtyRes = await this.getSysUserLoginActvty();
                    this.chartvalues = this.getDefaultDataSets(sysloginActvtyRes);

                }
            } catch (err) {
                let body = Logger.buildRequest(
                    COMPONENT_NAME.C_SYS_USER_LOGIN_ACTIVITY,
                    "error in  Created",
                    err.toString(),
                    " Created()",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
        },

  methods: {

      showAlert(val) {
                this.$emit("showAlert", val);
            },
            
      getDefaultDataSets(pLoginActvtyRes) {
            let retValue ={
                    dataSets : [],
                    labels: []
                }
            let n;
            let increment;
          try {
            if(BaseConfiguration.isDebug) console.log("getDefaultDataSets");
            if(pLoginActvtyRes && pLoginActvtyRes.UserLoginActivity) {
                for (let i = 0; i < pLoginActvtyRes.UserLoginActivity.length; i++) {
                    retValue.dataSets.push(pLoginActvtyRes.UserLoginActivity[i].logincount);

                                    
                    retValue.labels.push(this.$options.filters.formatDate(pLoginActvtyRes.UserLoginActivity[i].hour, "h A") )
                }
                if(Number(retValue.dataSets[retValue.dataSets.length-1]) <= 25){
                        n=25;
                        increment=5;
                    } 
                else if(Number(retValue.dataSets[0])>=25 && Number(retValue.dataSets[retValue.dataSets.length-1]) <= 50){
                        n=50;
                        increment=10;
                   }
                else if(Number(retValue.dataSets[0])>=50 && Number(retValue.dataSets[retValue.dataSets.length-1]) <= 100){
                        n=100;
                        increment=20;
                   } 
                   retValue.dataSets=[];
                for (let i = 0; i <=n; i=i+increment) {
                    retValue.dataSets.push(i);
                }
            }
      
          } catch (err) {
                  let body = Logger.buildRequest(
                    FILE_NAME.C_SYS_USER_LOGIN_ACTIVITY,
                    "error in getDefaultDataSets",
                    err.toString(),
                    "getDefaultDataSets",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            return retValue;
    }, 

       async getSysUserLoginActvty() {
                if (BaseConfiguration.isDebug) console.log("getSysUserLoginActvty");
                let returnValue;
                try {
                    let SysUserLoginActvtyReq = apiGetUserLoginActvty.buildRequest(); //constant

                    if (SysUserLoginActvtyReq != null) {
                        let SysUserLoginActvtyRes = await apiGetUserLoginActvty.getResponse(
                            SysUserLoginActvtyReq
                        );
                        if (VALIDATE_SUCCESS_RES(SysUserLoginActvtyRes)) {
                            returnValue = SysUserLoginActvtyRes.data.data;

                        } else {
                            let error = getErrorMessage(SysUserLoginActvtyRes);

                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.showAlert(getErrorAlertValue(error));
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_SYS_USER_LOGIN_ACTIVITY,
                        "error in  getSysUserLoginActvty",
                        err.toString(),
                        "getSysUserLoginActvty()",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return returnValue;
            },
  }
}

</script>